const NotFound = () => {
  return <div>Invalid User Status, Please contact customer support...</div>;
};

export default NotFound;
